export default __webpack_public_path__ + "static/media/delete2.492ddb88.svg";